import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (typeof this.props.onError === 'function') {
      try {
        this.props.onError(error, info);
      } catch {}
    }
    console.error('[FRONTEND ERROR BOUNDARY]', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.hasError &&
      (prevProps.children !== this.props.children ||
        (this.props.resetKey !== undefined && prevProps.resetKey !== this.props.resetKey))
    ) {
      this.setState({ hasError: false, error: null });
    }
  }

  handleReset = () => {
    if (typeof this.props.onReset === 'function') {
      try {
        this.props.onReset();
      } catch {}
    }
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children || null;
    }

    if (typeof this.props.fallback === 'function') {
      return this.props.fallback({
        error: this.state.error,
        resetErrorBoundary: this.handleReset,
      });
    }

    if (this.props.fallback) {
      return this.props.fallback;
    }

    const { message, style } = this.props;

    return (
      <div
        role="alert"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 16,
          padding: 32,
          fontFamily: 'inherit',
          ...style,
        }}
      >
        <div style={{ fontSize: 48 }} aria-hidden="true">⚠️</div>
        <h2 style={{ margin: 0, fontSize: '1.2rem', color: '#0f172a' }}>
          Something went wrong
        </h2>
        <p style={{ margin: 0, fontSize: '0.85rem', color: '#64748b', textAlign: 'center', maxWidth: 400 }}>
          {message || 'This section crashed. Rest of the app is working fine.'}
        </p>
        <button
          type="button"
          onClick={this.handleReset}
          style={{
            background: '#D4AF37',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '8px 20px',
            cursor: 'pointer',
            fontSize: '0.85rem',
            fontWeight: 600,
          }}
        >
          Try Again
        </button>
        {process.env.NODE_ENV === 'development' && this.state.error && (
          <pre
            style={{
              background: '#fef2f2',
              color: '#dc2626',
              borderRadius: 8,
              padding: 12,
              fontSize: '0.72rem',
              maxWidth: 600,
              overflow: 'auto',
              maxHeight: 200,
              textAlign: 'left',
            }}
          >
            {this.state.error.stack || this.state.error.toString()}
          </pre>
        )}
      </div>
    );
  }
}

